import script from "./layoutBasic.vue?vue&type=script&setup=true&lang=js"
export * from "./layoutBasic.vue?vue&type=script&setup=true&lang=js"

import "./layoutBasic.vue?vue&type=style&index=0&id=067eedd6&lang=css"

const __exports__ = script;

export default __exports__